import { Injectable } from '@angular/core';

// Not all actions are tracked, this object only handles manually added to it action emitions.
@Injectable()
export class RegisterFlowActionTracker {
    private readonly sessionKey = 'register-flow-actions-emitted'
    private actionsEmitted: string[] = [];

    constructor() {
        this.actionsEmitted = JSON.parse(sessionStorage.getItem(this.sessionKey)) ?? [];
    }

    isAlreadyEmited(actionName: string): boolean {
        return this.actionsEmitted.includes(actionName);
    }

    addEmition(actionName: string): void {
        if (!this.isAlreadyEmited(actionName)) {
            this.actionsEmitted.push(actionName)
            sessionStorage.setItem(this.sessionKey, JSON.stringify(this.actionsEmitted));
        }
    }
}
